// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SubtrackerNavbar_navbar__EIOdH {
  position: sticky;
  top: 70px;
  border-top: 1px solid #ededed;
  z-index: 1;
}
.SubtrackerNavbar_navbar__EIOdH .SubtrackerNavbar_navbarItem__kZixU {
  padding: 10px 20px;
  cursor: pointer;
  background-color: #fff;
  color: grey;
  border-bottom: 1px solid transparent;
  text-align: center;
  font-size: 12px;
}
.SubtrackerNavbar_navbar__EIOdH .SubtrackerNavbar_navbarItem__kZixU.SubtrackerNavbar_selectedItem__pc\\+yh {
  color: black;
  background-color: #f7f7f7;
  border-bottom: solid 1px #a1a1a1;
}`, "",{"version":3,"sources":["webpack://./src/components/organisms/SubtrackerNavbar/SubtrackerNavbar.module.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,SAAA;EACA,6BAAA;EACA,UAAA;AACF;AACE;EACE,kBAAA;EACA,eAAA;EACA,sBAAA;EACA,WAAA;EACA,oCAAA;EACA,kBAAA;EACA,eAAA;AACJ;AACI;EACE,YAAA;EACA,yBAAA;EACA,gCAAA;AACN","sourcesContent":[".navbar {\r\n  position: sticky;\r\n  top: 70px;\r\n  border-top: 1px solid #ededed;\r\n  z-index: 1;\r\n\r\n  .navbarItem {\r\n    padding: 10px 20px;\r\n    cursor: pointer;\r\n    background-color: #fff;\r\n    color: grey;\r\n    border-bottom: 1px solid transparent;\r\n    text-align: center;\r\n    font-size: 12px;\r\n  \r\n    &.selectedItem {\r\n      color: black;\r\n      background-color: #f7f7f7;\r\n      border-bottom: solid 1px #a1a1a1;\r\n    }\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"navbar": `SubtrackerNavbar_navbar__EIOdH`,
	"navbarItem": `SubtrackerNavbar_navbarItem__kZixU`,
	"selectedItem": `SubtrackerNavbar_selectedItem__pc+yh`
};
export default ___CSS_LOADER_EXPORT___;
